import axiosInstance from "@/api/axiosInstance";
import {
  CoachAttemptDetail,
  SaveCoachResponsesPayload,
} from "@/modules/growthStages/features/Diagnostics/types/diagnostic";

export const saveCoachResponses = async (
  attemptId: number,
  payload: SaveCoachResponsesPayload,
): Promise<CoachAttemptDetail> => {
  const response = await axiosInstance.put<CoachAttemptDetail>(
    `/api/private/attempts/${attemptId}/responses`,
    payload,
  );
  return response.data;
};
